/**
 * <product-price>: swaps in the pre-rendered price for the chosen variant.
 *
 * Listens for the `variant:change` event dispatched by <variant-picker>. Each variant's price
 * markup is rendered by the server into a <template data-variant-id> inside this element.
 */
(() => {
  // Loaded once per price block: skip when already registered
  if (customElements.get('product-price')) return;

  class ProductPrice extends HTMLElement {
    #abort = new AbortController();

    connectedCallback() {
      document.addEventListener('variant:change', this.#handleVariantChange, { signal: this.#abort.signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    /** @param {Event} event */
    #handleVariantChange = (event) => {
      if (!(event instanceof CustomEvent) || !(event.target instanceof Element)) return;

      // Ignore pickers for other products on the page (e.g. quick add or recommendations)
      const picker = event.target.closest('variant-picker');
      if (picker instanceof HTMLElement && picker.dataset.productId !== this.dataset.productId) return;

      const template = this.querySelector(`template[data-variant-id="${event.detail.variant.id}"]`);
      const current = this.querySelector(':scope > .product-price__amounts');
      const next = template instanceof HTMLTemplateElement ? template.content.firstElementChild : null;

      if (current && next) current.replaceWith(next.cloneNode(true));
    };
  }

  customElements.define('product-price', ProductPrice);
})();
